import React from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Table, TableBody, TableCell,
  TableHead, TableRow, Typography,
} from "@mui/material";
import { daysBetween, shortDate } from "./utils/ganttLayout";

/** The students behind a centre's "Independent students" row, with their own dates. */
export default function IndependentStudentsDialog({ open, centre, onClose, onSelectStudent }) {
  const students = centre?.indies?.students || [];
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {centre?.name}: independent students
        <Typography variant="body2" color="text.secondary">
          {students.length} {students.length === 1 ? "stay" : "stays"}, at most {centre?.indies?.peak || 0} on site on one night
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Student</TableCell>
              <TableCell>Arrives</TableCell>
              <TableCell>Departs</TableCell>
              <TableCell align="right">Nights</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {students.map((s) => {
              // Blank names happen (empty name fields): the ID still identifies the student.
              const name = String(s.name || "").trim();
              const label = name || <Typography component="span" variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>No name</Typography>;
              return (
              <TableRow key={`${s.studentId}-${s.arrival}`} hover>
                <TableCell>
                  {onSelectStudent ? (
                    <Link component="button" underline="hover" onClick={() => onSelectStudent(s.studentId)}>
                      {s.studentId}
                    </Link>
                  ) : s.studentId}
                </TableCell>
                <TableCell>
                  {onSelectStudent && name ? (
                    <Link component="button" underline="hover" onClick={() => onSelectStudent(s.studentId)}>
                      {name}
                    </Link>
                  ) : label}
                </TableCell>
                <TableCell>{shortDate(s.arrival)}</TableCell>
                <TableCell>{shortDate(s.departure)}</TableCell>
                <TableCell align="right">{daysBetween(s.arrival, s.departure)}</TableCell>
              </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
